<template>
  <footer class="footer-bg">
    <div class="footer-container">
      <div class="footer-item-top">
        <img src="../assets/imgs/widi-logo-xs.png" />
        <div class="other-logo">
          <a href="https://www.facebook.com/TheWidi" target="_blank">
            <img src="../assets/imgs/Icons/facebook.jpeg" />
          </a>
          <a href="https://mobile.twitter.com/thewidisoftware" target="_blank">
            <img src="../assets/imgs/Icons/twitter.jpeg" />
          </a>
          <a href="https://www.linkedin.com/company/thewidi/" target="_blank">
            <img src="../assets/imgs/Icons/linkedin.jpeg" />
          </a>
        </div>
      </div>
      <div class="footer-item-bottom">
        <div class="bottom-item">
          <span>© {{ year }} Widi · All rights reserved</span>
          <a v-show="screenWidth > 768" :href="helpUrl" target="_blank">
            · Help
          </a>
          <router-link v-show="screenWidth > 768" :to="{ name: 'Contact' }">
            · Contact
          </router-link>
        </div>
        <!-- <div class="bottom-item" v-text="tit"></div> -->
        <div class="bottom-item">
          <router-link
            :to="{ path: '/PrivacyTerms', query: { name: 'privacy' } }"
            >Privacy ·
          </router-link>
          <router-link :to="{ path: '/PrivacyTerms', query: { name: 'terms' } }"
            >Terms
          </router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      helpUrl: process.env.VUE_APP_BASE_URL,
      year: '2020'
    };
  },
  props: ["screenWidth"],
  created() {
    const nowDate = new Date()
    this.year = nowDate.getFullYear()
  }
};
</script>

<style lang="scss" scoped>
.footer-bg {
  overflow: hidden;
  .footer-container {
    max-width: 940px;
    margin: 90px auto;
    font-size: 16px;
    color: #231F20;
    opacity: 0.8;
    .footer-item-top,
    .footer-item-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;
      & > img {
        width: 50px;
        height: 30px;
        object-fit: cover;
      }
      .other-logo {
        display: flex;
        justify-content: space-between;
        width: 100px;
      }
      .iconfont {
        width: 22px;
        height: 22px;
        background: rgba(35, 31, 32, 0.8);
        color: white;
        padding: 0;
        font-size: unset;
        text-align: center;
        border-radius: 3px;
        line-height: 22px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .footer-bg {
    .footer-container {
      display: flex;
      flex-direction: column;
      margin: 60px auto 75px;
      .footer-item-top {
        margin: 0;
        flex-direction: column;
        justify-content: center;
        .other-logo{
          margin-top: 20px;
        }
      }
      .footer-item-bottom {
        flex-direction: column-reverse;
        .bottom-item {
          text-align: center;
          margin-top: 30px;
        }
      }
    }
  }
}
</style>
